import worldwide from "../../../assets/images/worldwide.svg"
import trust from "../../../assets/images/trust.svg"
import tracking from "../../../assets/images/tracking.svg"
import blog1 from "../../../assets/images/blog1.svg"
import blog2 from "../../../assets/images/blog2.svg"
import blog3 from "../../../assets/images/blog3.svg"
import shipment from "../../../assets/images/shipmentBox.svg"
import quotes from "../../../assets/images/quotes.svg"
import facebook from "../../../assets/images/facebook.svg"
import linkedin from "../../../assets/images/linkedin.svg"
import tiktok from "../../../assets/images/tiktok1.svg"
import instagram from "../../../assets/images/instagram.svg"

export const CardDetails = [
  {
    icons: shipment,
    title: "Log Your Shipment",
    content:
      "Sign in to our app, enter your cargo details, and confirm your booking",
  },
  {
    icons: trust,
    title: "Get a Quote",
    content:
      "Receive an instant, transparent quote tailored to your shipping needs.",
  },
  {
    icons: tracking,
    title: "Track Your Shipment",
    content:
      "Use our real-time tracking system to monitor your shipment from pickup to delivery",
  },
  {
    icons: worldwide,
    title: "Delivery Made Simple",
    content:
      "Receive updates as your shipment reaches its destination securely and on time.",
  },
]

export const CardTwoDetails = [
  {
    title: "Effortless Lodging",
    content:
      "Our user-friendly platform allows you to log your shipment in minutes. No paperwork, no hassle – just simple, streamlined steps",
  },
  {
    title: "Real-Time Tracking",
    content:
      "Stay connected to your shipment at every stage. From pickup to delivery, our live tracking ensures complete visibility and peace of mind",
  },
  {
    title: "Instant Pricing",
    content:
      "Get competitive quotes instantly. Our advanced pricing algorithm ensures you only pay for what you need – no hidden fees",
  },
  {
    title: "Secure Delivery",
    content:
      "Trust us to handle your cargo with care. Our global network guarantees timely and secure deliveries every time",
  },
]

export const BlogDetails = [
  {
    images: blog1,
    title: "Freight Services",
    content:
      "Efficient and reliable freight services are at the core of modern logistics, enabling the seamless transportation of goods across various distances and modes. Our freight services are tailored to meet your needs, combining advanced tracking technology with unmatched expertise for dependable and hassle-free logistics.",
    date: "",
  },
  {
    images: blog2,
    title: "Express & Courier Services",
    content:
      "Fast and dependable delivery is essential for businesses and individuals alike, which is why our express and courier services are designed to meet your time-sensitive needs. With a commitment to speed, reliability, and excellent customer service, we make sure your parcels arrive on time, every time, no matter the destination.",
    date: "",
  },
  {
    images: blog3,
    title: "Warehousing & Storage",
    content:
      "Secure and efficient storage solutions are vital for managing goods effectively. Our warehousing and storage services cater to diverse business needs, ensuring your products are stored safely and are readily accessible when needed. With state-of-the-art facilities, we provide a comprehensive storage solution for businesses of all sizes.",
    date: "",
  },
]

export const whatWeDo = [
  {
    icons: quotes,
    title:
      "Logistifly saved our business countless hours with their streamlined process. The real-time tracking gave us peace of mind we didn’t know we needed!",
    content: "Corporate Client",
    contentTwo: "Logistics Manager",
  },
  {
    icons: quotes,
    title:
      "From booking to delivery, Logistifly’s platform is intuitive and reliable. We’ll never go back to the old way of shipping.",
    content: "Ajani Ibrahim",
    contentTwo: "Small Business Owner",
  },
  {
    icons: quotes,
    title:
      "Exceptional service! The instant quotes make planning so much easier.",
    content: "Frequent Shipper",
    contentTwo: "E-commerce Entrepreneur",
  },
]

export const AccordionItems = [
  {
    title: "Section 1",
    content: "Content for section 1.",
  },
  {
    title: "Section 2",
    content: "Content for section 2.",
  },
  {
    title: "Section 3",
    content: "Content for section 3.",
  },
  {
    title: "Section 4",
    content: "Content for section 4.",
  },
  {
    title: "Section 5",
    content: "Content for section 5.",
  },
]

export const navLists = [
  {
    id: 1,
    list: "ABOUT",
    to: "about",
  },
  {
    id: 2,
    list: "SERVICES",
    to: "services",
  },
  {
    id: 3,
    list: "CONTACT",
    to: "contact",
  },
]

export const socials = [
  {
    id: 1,
    icon: facebook,
    link: "https://www.facebook.com/people/Logistifly-App/61569833158254/",
  },
  {
    id: 2,
    icon: instagram,
    link: "https://www.instagram.com/logistifly24/",
  },
  {
    id: 3,
    icon: linkedin,
    link: "https://www.linkedin.com/company/logistigfly/",
  },
  {
    id: 4,
    icon: tiktok,
    link: "https://www.tiktok.com/@logistiflyapp?_t=8sGEIytXDML&_r=1",
  },
]

export const ourDetails = [
  {
    name: "About",
    link: "#about",
  },
  {
    name: "Get Quote",
    link: "#get-quote",
  },
  {
    name: "Servives",
    link: "#services",
  },
  {
    name: "Privacy Policy",
    link: "/privacy-policy",
  },
]
